<div class="content">
    <div class="content">
     <div class="container-fluid">
     <div class="row">
     <div class="col-lg-12 col-md-12 col-sm-12 common_title">
     <h2>GENERATION OF OTHER GRAPHS</h2>
     <!--<p>Generation of other graphs</p>-->
      <a [routerLink]="['/dashboard','Reportmanagement']" class="back_to"><i class="fa fa-chevron-left" aria-hidden="true"></i> Back</a>
     </div>
     </div>
     <div class="row">
      <div class="col-lg-2 col-sm-3 col-12 " style="margin-top: 11px;">
        <div class="form-group" >
        <form enctype="application/x-www-form-urlencoded" role="form" autocomplete="off" >
          <fieldset>
            <date-range-picker [options]="" [controlName]="'rightDateRange'" aria-readonly="true"></date-range-picker>
          </fieldset>
        </form>
        </div>
       </div>
     <div class="col-lg-2 col-md-3 col-sm-12">
        <div class="form-group multiple">
        <label for="Species Name">Farm Name</label>
        <select  name="farmname" id="farmname" class="form-control selectpicker myFakeClass" >
          <option *ngFor='let farmlist of getfarmsListData' [value]="farmlist.tnfr_id">{{farmlist.tnfr_name}}</option>
        </select>
        </div>
      </div>
      <div class="col-lg-2 col-md-3 col-sm-12">
          <div class="form-group">
          <label for="Species Name">Species Name</label>
          <select id="Speciesname" class="selectpicker form-control myFakeClass1" (change)="breedselectbyspecies($event)">
            <option *ngFor='let specieslist of speciesloaddata' [value]="specieslist.id">{{specieslist.name}}</option>
          </select>
          </div>
          </div>
          <div class="col-lg-2 col-md-3 col-sm-12">
            <div class="form-group">
            <label for="Breed Name">Breed Name</label>
            <select id="BreedName" class="selectpicker form-control myFakeClass2">
              <option *ngFor='let breedname of getspeciesvalue' [value]="breedname.id">{{breedname.name}}</option>
            </select>
            </div>
            </div>
            <div class="col-lg-2 col-sm-3 col-12" >
              <div class="form-group">
                 <label for="Breed Name">Age</label>
                 <select id="age" class="selectpicker form-control myFakeClass3" >
                  <option *ngFor='let age_data of get_age' [value]="age_data.tnag_id">{{age_data.tnag_name}}({{age_data.tnag_time_range}}) </option>
                </select>
              </div>
             </div>
             <div class="col-lg-1 col-sm-3 col-12">
              <div class="form-group">
                <label for="Breed Name"></label>
                 <span class="input-group-btn">
                     <button class="btn btn-primary search" type="button" (click)="get_datas()" ><span class="fa fa-search"></span> Search</button>
                 </span>
                </div>
                
          </div>
          <div class="col-lg-1 col-sm-3 col-12" style="margin-top: 18px;">
            <div class="form-group">
              <span class="input-group-btn">
                <button class="btn btn-primary" type="button" (click)="exportdata()" ><span class="fa fa-download"></span></button>
              </span>
           </div>

          </div>
     </div>
     <div id="contentToConvert">
     <div class="col-lg-12 col-md-12 col-sm-12 common_title">
       <h3 class="headin"  >{{from_date}} - {{to_date}} Month-Wise EADR</h3>
       </div>
     <div class="col-lg-12 col-md-12 col-sm-12  card_div">
        <div class="card" >
          <!-- <google-chart 
          [type]="chartData.type" 
          [data]="chartData.data" 
          [columns]="chartData.columnNames" 
          [options]="chartData.options" 
          [width]="chartData.width"
          [height]="chartData.height">
            
          </google-chart> -->
       </div>
     </div>
     <div class="col-lg-12 col-md-12 col-sm-12 common_title ">
        <h3 class="headin" >{{from_date}} - {{to_date}}  Month-Wise EADR</h3>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12  card_div">
            <div class="card" >
              <!-- <google-chart 
              [type]="chartData1.type" 
              [data]="chartData1.data" 
              [columns]="chartData1.columnNames" 
              [options]="chartData1.options" 
              [width]="chartData1.width"
              [height]="chartData1.height">
                
              </google-chart> -->
           </div>
         </div>
        </div>     
</div>
</div>
</div>
